import { createPlugin } from '@backstage/core-plugin-api';
import {
  TechDocsAddonLocations,
  createTechDocsAddonExtension,
} from '@backstage/plugin-techdocs-react';

import { EditWikiAddon, EditWikiProps } from './components/EditWiki';

export const techdocsAddonWikiPlugin = createPlugin({
  id: 'techdocs-addon-wiki',
});

export const EditWiki = techdocsAddonWikiPlugin.provide(
  createTechDocsAddonExtension<EditWikiProps>({
    name: 'EditWiki',
    location: TechDocsAddonLocations.SecondarySidebar,
    component: EditWikiAddon,
  }),
);
